/**
 * Shared Starter → Pro upgrade helpers (lockout overlay + billing page).
 */

import { hasPaymentMethodFromSummary } from './subscriptionBilling'

var BILLING_SETTINGS_PATH = '/settings/billing'
var OPEN_PAYMENT_MODAL_MAX_ATTEMPTS = 30

export { hasPaymentMethodFromSummary }

/** Hide past-due lockout while the Stripe payment modal is open. */
export function startBillingPaymentModalFlow (root) {
  if (root) root.billingPaymentModalFlowActive = true
}

export function endBillingPaymentModalFlow (root) {
  if (root) {
    root.billingPaymentModalFlowActive = false
    root.pendingOpenBillingPaymentModal = false
  }
}

function tryInvokeOpenBillingPaymentModal (vm, attempt) {
  if (!vm || !vm.$root) return
  if (typeof vm.$root.openBillingPaymentModal === 'function') {
    startBillingPaymentModalFlow(vm.$root)
    vm.$root.pendingOpenBillingPaymentModal = false
    vm.$root.openBillingPaymentModal()
    return
  }
  if (attempt >= OPEN_PAYMENT_MODAL_MAX_ATTEMPTS) return
  setTimeout(function () {
    tryInvokeOpenBillingPaymentModal(vm, attempt + 1)
  }, 80 + attempt * 40)
}

/** Navigate to billing (if needed) and open the Stripe add/update payment modal. */
export function requestOpenBillingPaymentModal (vm) {
  if (!vm || !vm.$root) return
  startBillingPaymentModalFlow(vm.$root)
  vm.$root.pendingOpenBillingPaymentModal = true
  vm.$root.$emit('billing-open-payment-modal')
  if (vm.$route.path !== BILLING_SETTINGS_PATH) {
    vm.$router.push(BILLING_SETTINGS_PATH)
  }
  tryInvokeOpenBillingPaymentModal(vm, 0)
}

export function resolveHasPaymentMethod (vm) {
  if (hasPaymentMethodFromSummary(vm.$root && vm.$root.subscriptionSummary)) {
    return Promise.resolve(true)
  }
  return vm.$http.get('/api/billing/payment-methods').then(function (res) {
    var body = res.body || {}
    var raw = body.paymentMethods || body.payment_methods || body.data
    if (Array.isArray(raw) && raw.length > 0) return true
    if (Array.isArray(body) && body.length > 0) return true
    if (body && body.id) return true
    return false
  }, function () {
    return false
  })
}

function refreshSummaryAfterUpgrade (vm, res) {
  if (vm.$root && vm.$root.loadSubscriptionSummary) {
    return vm.$root.loadSubscriptionSummary().then(function () {
      return res
    })
  }
  return Promise.resolve(res)
}

/**
 * @param {'starter'|'pro'|'pro_annual'} planKey
 */
export function upgradeSubscriptionToPlan (vm, planKey) {
  return vm.$http.put('/api/billing/subscription/upgrade', { plan: planKey || 'pro' }).then(function (res) {
    return refreshSummaryAfterUpgrade(vm, res)
  })
}

export function upgradeSubscriptionToPro (vm) {
  return upgradeSubscriptionToPlan(vm, 'pro')
}



// WEBPACK FOOTER //
// ./src/utils/billingUpgrade.js